import { countSpecies } from "@/features/farm"
import { useGetAnimalsQuery } from "@/features/farm/api/animals-api.ts"
import { useGetSpeciesQuery } from "@/features/farm/api/species-api.ts"

export const useGetAnimalsCountMap = () => {
  const { data: species_breeds = {} } = useGetSpeciesQuery()
  const { data: animals = [] } = useGetAnimalsQuery()

  const inFarmAnimals = animals.filter((animal) => !animal.exit_date)

  return countSpecies(inFarmAnimals, species_breeds)
}
